// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — window.styled.classic.js, новая — window.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './window.styled.classic';
import * as cp from './window.styled.cp';

export const Close = isCp ? cp.Close : classic.Close;
export const Content = isCp ? cp.Content : classic.Content;
export const Header = isCp ? cp.Header : classic.Header;
export const Menu = isCp ? cp.Menu : classic.Menu;
export const Tab = isCp ? cp.Tab : classic.Tab;
export const TabsBox = isCp ? cp.TabsBox : classic.TabsBox;
